<div class="modal-header">
  <div>
    <i class="mdi mdi-map-marker-multiple"></i>
    <span class="header">Select where test will run</span>
  </div>
  <div class="btn-group">
    <button mat-flat-button (click)="closeModal()" class="save-btn" [disabled]="disableSave()">
      SAVE
    </button>
    <i class="mdi mdi-close close-icon" mat-dialog-close></i>
  </div>
</div>
<div class="table-container device-picker-content" *ngIf="opened">
  <viavi-table
    [tableConfigurations]="table"
    [isActionEnabled]="true"
    (sendSeletedItem)="sendSelectedItem($event)"
    (sendRowAction)="onActionClick($event)"
  ></viavi-table>
</div>
